import { render, staticRenderFns } from "./TreatmentTypeEditForm.vue?vue&type=template&id=2841c054&scoped=true"
import script from "./TreatmentTypeEditForm.vue?vue&type=script&lang=js"
export * from "./TreatmentTypeEditForm.vue?vue&type=script&lang=js"
import style0 from "./TreatmentTypeEditForm.vue?vue&type=style&index=0&id=2841c054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841c054",
  null
  
)

export default component.exports